import type { StyleDictionary } from 'pdfmake/interfaces'

export const styles: StyleDictionary = {
  headerAnexos: {
    fontSize: 11,
    bold: true,
    color: 'black'
  },
  notaPie: {
    fontSize: 7.5,
    color: '#333',
    alignment: 'justify'
  },
  headerRight: {
    fontSize: 9,
    bold: true,
    alignment: 'right'
  },
  header: {
    fontSize: 11,
    bold: true,
    color: 'black'
  },
  subheaderTech: {
    fontSize: 8.5,
    bold: true,
    color: 'black'
  },
  subheader: {
    fontSize: 7.5,
    bold: true,
    color: 'black'
  },
  headerTitle:{
    fontSize: 12,
    bold: true,
  },
  headerSubtitle:{
    fontSize: 7,
    color: '#555',
  },
  headerSubtitleBold:{
    fontSize: 7,
    bold: true,
    color: '#555',
  },
  tableHistoria: {
    margin: [0, 5, 0, 10]
  },
  tableHeaderLeft: {
    bold: true,
    alignment: 'left',
    fontSize: 8
  },
  tableHeader: {
    bold: true,
    alignment: 'center',
    fontSize: 8
  },
  tableHeaderSmall: {
    bold: true,
    margin: [0, 5, 0, 0],
    fontSize: 9
  },
  tituloCell: {
    color: '#000000',
    margin: [0, 0, 0, 2],
    fontSize: 7,
    bold: true
  },
  textoCell: {
    fontSize: 7.5
  },
  footerPageLeft: {
    marginLeft: 20,
    fontSize: 6,
    color: '#555',
    bold: true
  },
  footerPageRicht: {
    fontSize: 6,
    color: '#555',
    alignment: 'right',
    bold: true
  },
  footerPageCenter: {
    fontSize: 6,
    color: '#555',
    alignment: 'center',
    bold: true
  },
  cardTitle: {
    fontSize: 9,
    bold: true,
    alignment: 'center',
    margin:[ 0, 0, 0, 0 ]
  },
  tableCell: {
    fontSize: 6,
    color: '#333333',
  },
  tableCellSmall: {
    fontSize: 7,
    color: '#333333',
  },
  cardLabel: {
    fontSize: 11,
    color: '#555'
  },
  cardBlock: {
    margin: [10, 10, 10, 10]
  },
  serioHeader: {
    fontSize: 14,
    bold: true,
    color: '#111',
    margin: [0, 0, 0, 8]
  },
  serioLabel: {
    fontSize: 10,
    color: '#444',
    bold: true,
    margin: [0, 2, 0, 2]
  },
  serioValue: {
    fontSize: 10,
    color: '#111',
    margin: [0, 2, 0, 2]
  },
  serioBlock: {
    margin: [10, 10, 10, 10]
  },
  serioLabelSmall: {
    fontSize: 8,
    color: '#444',
    margin: [0, 1, 0, 1]
  },
  serioLabelBold: {
    fontSize: 9,
    color: '#222',
    bold: true,
    margin: [0, 2, 0, 2]
  },
  itemTicked: {
    fontSize: 6.5,
    bold: true,
    color: '#555',
  }
}

export const listColums = {
  'col-span-1': 1,
  'col-span-2': 2,
  'col-span-3': 3,
  'col-span-4': 4,
  'col-span-5': 5,
  'col-span-6': 6,
  'col-span-7': 7,
  'col-span-8': 8,
  'col-span-9': 9,
  'col-span-10': 10,
  'col-span-11': 11,
  'col-span-12': 12
} as Record<string, number>

export const pdfTableLayout = {
  // fillColor: (rowIndex: number) => (rowIndex === 0 ? '#f2f9ff' : null),
  hLineWidth: () => 0.5,
  vLineWidth: () => 0.5,
  hLineColor: () => '#000000',
  vLineColor: () => '#000000',
  paddingLeft: () => 2,
  paddingRight: () => 2,
  paddingTop: () => 1,
  paddingBottom: () => 1
}

export const pdfTablePatient = {
  // fillColor: (rowIndex: number) => (rowIndex === 0 ? '#f2f9ff' : null),
  hLineWidth: () => 0.5,
  vLineWidth: () => 0,
  hLineColor: () => '#000000',
  vLineColor: () => '#000000',
  paddingLeft: () => 2,
  paddingRight: () => 2,
  paddingTop: () => 1,
  paddingBottom: () => 1
}

export const pdfCardBox = {
  border: [true, true, true, true],
  borderColor: '#000000',
  borderRadius: 3
}
